export enum UserRole {
  SUPERADMIN='superAdmin',
  ADMIN = 'admin',
  USER = 'user',
  VIEWER = 'viewer',
  TEAMMANAGER='teamManager'
}

export interface IUser {
  id: string;
  username: string;
  email: string;
  role: UserRole;
}
